import { IonButton, IonItem, IonLabel, IonIcon } from '@ionic/react';
import moment from 'moment';
import {downloadInvoice, downloadInvoices} from "./downloadInvoice";
import { download } from 'ionicons/icons';

export const InvoiceRow = ({color, job, history}) => (
  <IonItem color={color}
    detail={true}
    detailIcon={download}
    onClick={(e) => {
      e.stopPropagation();
      downloadInvoices(job);
    }}
    lines='none'
  >
    <IonLabel>
      {job.booking !== null &&
        <h3><strong>{job.booking.id} - {job.property.name} - {job?.booking?.guesttype}</strong></h3>
      }
      <h3 className='job-secondary'>
        {job.invoice.id} - {' '}
        {moment(job.invoiceapproveddatetime).format('ddd Do MMM YYYY')} –{' '}
        {job.fulldescription || job.shortdescription}
      </h3>
    </IonLabel>
  </IonItem>
);
